import { styled } from '@mui/material/styles';
import { Box, BoxProps } from 'shared/mui/Box';

type StyledToolbarBoxProps = {
  open: boolean;
} & BoxProps;

export const StyledToolbarBox = styled(Box)<StyledToolbarBoxProps>(({ open }) => ({
  width: open ? '306px' : '65px',
  paddingLeft: open ? '16px' : '12px',
  height: '48px',
  display: 'flex',
  alignItems: 'center',
  transition: 'width, padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
}));

export const StyledBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});
